import React, { createContext, useContext, useReducer } from 'react';
import logger from 'use-reducer-logger';
import { setItem as setStorageItem } from '../helpers/localStorage';

const SearchStateLocationContext = createContext(null);

const SearchStateLocationDispatchContext = createContext(null);

export function SearchStateLocationProvider({ children }) {
    const [searchState, dispatch] = useReducer(
        process.env.NODE_ENV === 'development' ? logger(searchStateLocationReducer) : searchStateLocationReducer,
        initialSearchLocation
    );

    return (
        <SearchStateLocationContext.Provider value={searchState}>
            <SearchStateLocationDispatchContext.Provider value={dispatch}>
                {children}
            </SearchStateLocationDispatchContext.Provider>
        </SearchStateLocationContext.Provider>
    );
}

export function useSearchStateLocation() {
    return useContext(SearchStateLocationContext);
}

export function useSearchStateLocationDispatch() {
    return useContext(SearchStateLocationDispatchContext);
}

function searchStateLocationReducer(existingState, action) {
    switch (action.type) {
        case 'selectState': {
            const nextState = {
                ...initialSearchLocation,
                stateAsLocation: {
                    name: action.stateAsLocation.name,
                    abbr: action.stateAsLocation.abbr,
                },
            };
            window.algoliaSearchState.stateAsLocation = nextState.stateAsLocation;
            window.algoliaSearchState.submarket = initialSearchLocation.submarket;
            window.algoliaSearchState.cities = initialSearchLocation.cities;
            setStorageItem('state', action.stateAsLocation.name);
            setStorageItem('submarket', initialSearchLocation.submarket.submarket);
            return nextState;
        }
        case 'selectSubmarket': {
            const nextState = {
                ...existingState,
                submarket: action.submarket,
                cities: initialSearchLocation.cities,
                stateAsLocation: initialSearchLocation.stateAsLocation,
            };
            window.algoliaSearchState.stateAsLocation = initialSearchLocation.stateAsLocation;
            window.algoliaSearchState.submarket = nextState.submarket;
            window.algoliaSearchState.cities = initialSearchLocation.cities;
            setStorageItem('state', initialSearchLocation.stateAsLocation.name);
            setStorageItem('submarket', action.submarket.submarket);
            return nextState;
        }
        case 'setCities': {
            const nextState = {
                ...existingState,
                cities: action.cities,
            };
            window.algoliaSearchState.cities = nextState.cities;
            return nextState;
        }
        case 'addCity': {
            const nextState = {
                ...existingState,
                cities: [...existingState.cities, action.city],
            };
            window.algoliaSearchState.cities = nextState.cities;
            return nextState;
        }
        case 'removeCity': {
            const nextState = {
                ...existingState,
                cities: existingState.cities.filter((city) => city !== action.city),
            };
            window.algoliaSearchState.cities = nextState.cities;
            return nextState;
        }
        case 'reset': {
            window.algoliaSearchState.stateAsLocation = initialSearchLocation.stateAsLocation;
            window.algoliaSearchState.submarket = initialSearchLocation.submarket;
            window.algoliaSearchState.cities = initialSearchLocation.cities;
            return initialSearchLocation;
        }
        case 'openLocationSelector': {
            return {
                ...existingState,
                isLocationSelectorOpen: true,
            };
        }
        case 'closeLocationSelector': {
            return {
                ...existingState,
                isLocationSelectorOpen: false,
            };
        }
        case 'toggleLocationSelector': {
            return {
                ...existingState,
                isLocationSelectorOpen: !existingState.isLocationSelectorOpen,
            };
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

const initialSearchLocation = {
    // for map & top level state selection from location selector
    stateAsLocation: {
        abbr: null,
        name: null,
    },
    // for submarket selection from location selector
    submarket: {
        // e.g. Texas
        state: null,
        // e.g. TX
        stateAbbreviation: null,
        // e.g. Dallas-Forth Worth or Phoenix Metro
        submarket: null,
        // e.g. phoenix-metro
        slug: null,
    },
    cities: [],
    isLocationSelectorOpen: false,
};

if (!window.algoliaSearchState) {
    window.algoliaSearchState = {};
}
window.algoliaSearchState.stateAsLocation = initialSearchLocation.stateAsLocation;
window.algoliaSearchState.submarket = initialSearchLocation.submarket;
window.algoliaSearchState.cities = initialSearchLocation.cities;
